export default __webpack_public_path__ + "static/flag-fr-df78dc1cd43e8e9b235f8d16dc9ffcc4.svg";